// NPM
import React, { useState, useEffect, Fragment } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';

// COMPONENTS
import Statistics from '../../components/admin/systemmonitor/Statistics';
import MessageLog from '../../components/admin/systemmonitor/MessageLog';
import AuthLog from '../../components/admin/systemmonitor/AuthLog';
import Layout from '../../components/layouts/Layout';

// NETWORK
import useAdminRequest from '../../requests/AdminRequest';

// I18N
import SystemMonitorFormattedMessages from '../../messages/admin/SystemMonitorFormattedMessages';

// ROUTES
import { AdminRoutes } from '../../routes/AdminRoutes';

const SystemMonitor = (props) => {
  const [tab, setTab] = useState('MessageLog');
  const [totalStats, setTotalStats] = useState([]);
  const [totalTwilioStats, setTotalTwilioStats] = useState([]);
  const [primaryQueueStats, setPrimaryQueueStats] = useState([]);
  const [statsPageReady, setStatsPageReady] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [firstRefresh, setFirstRefresh] = useState(true);
  const [routeNameResults, setRouteNameResults] = useState([]);
  const [selectedRouteName, setSelectedRouteName] = useState(null);
  const {
    getMuxIdDrilldown,
    getPrimaryQueueStats,
    getTotalStatsPerMuxId,
    getTotalTwilioStatsPerMuxId,
  } = useAdminRequest();

  useEffect(() => {
    if (props.customer && props.customer !== null) {
      getStats();
    }
  }, [props.customer]);

  const handleGetMuxIdDrilldown = async (muxId, isTwilio) => {
    try {
      let muxIdDrilldown = await getMuxIdDrilldown(
        muxId,
        isTwilio,
        props.errorHandler
      );
      return muxIdDrilldown;
    } catch (e) {
      console.log(e);
    }
  };

  const getStats = async () => {
    try {
      let primaryQueueStats = await getPrimaryQueueStats(props.errorHandler);
      let totalStats = await getTotalStatsPerMuxId(props.errorHandler);
      let totalTwilioStats = await getTotalTwilioStatsPerMuxId(
        props.errorHandler
      );
      setTotalStats(totalStats);
      setTotalTwilioStats(totalTwilioStats);
      setPrimaryQueueStats(primaryQueueStats);
      setStatsPageReady(true);
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * Generates the tabs for the system monitor: 'Statistics', 'Recent' and 'Search'
   * @returns
   */
  const generateTabs = () => {
    return (
      <Fragment>
        <Box sx={{ borderBottom: 2, borderColor: 'divider' }}>
          <Tabs
            value={tab}
            onChange={(event, newValue) => {
              setTab(newValue);
            }}
            aria-label="system monitor tabs"
          >
            <Tab
              label="Message Log"
              value="MessageLog"
              sx={{ paddingTop: 0.5 }}
            />
            <Tab label="Auth Log" value="AuthLog" sx={{ paddingTop: 0.5 }} />
            <Tab
              label="Statistics"
              value="Statistics"
              sx={{ paddingTop: 0.5 }}
            />
          </Tabs>
        </Box>

        <Box sx={{ padding: 2 }}>
          {tab === 'MessageLog' && <MessageLog />}
          {tab === 'AuthLog' && <AuthLog />}
          {tab === 'Statistics' && (
            <Statistics
              primaryQueueStats={primaryQueueStats}
              totalStats={totalStats}
              totalTwilioStats={totalTwilioStats}
              statsPageReady={statsPageReady}
              getMuxIdDrilldown={handleGetMuxIdDrilldown}
            />
          )}
        </Box>
      </Fragment>
    );
  };

  /**
   * Generates the system monitor tab and all of its content, if user is God Admin.
   * @returns
   */
  const renderContent = () => {
    const { accessLevel, accessType } = props;

    // Show admin search forms
    if (accessLevel === '3' && accessType === '3') {
      return (
        <Layout
          routes={AdminRoutes}
          title={SystemMonitorFormattedMessages.systemMonitorTitle}
          titleRowRightComponent={
            <Typography gutterBottom>
              Environment: {process.env.REACT_APP_ENV || 'local'}
            </Typography>
          }
          accessLevel={accessLevel}
          accessType={accessType}
        >
          {errorState ? 'Error' : generateTabs()}
        </Layout>
      );
    }

    return null;
  };

  return renderContent();
};

export default SystemMonitor;
